module.exports = ".center {\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor-setup/new-vendor/new-vendor.component.scss
// module id = ./src/app/pages/vendor-setup/new-vendor/new-vendor.component.scss
// module chunks = main